<template>
  <span>
    <b-dropdown :disabled="disabled" variant="whiteT" class="mr-3" style="height: 40px;">
      <template #button-content>
        <div class="pcard--status">
          <span class="align-middle">
            <policy-status :acceptance="selected" />
          </span>
          <span v-if="showText" class="mr-1 ml-1">{{ text }}</span>
          <i class="bx bx-chevron-down text-muted font-size-24 align-middle"></i>
        </div>
      </template>
      <b-dropdown-item v-for="option in options" :key="option.definition" @click="select(option)" :disabled="option.definition == selected">
        <span class="align-middle">
          <policy-status :acceptance="option.definition" />
        </span>
        {{ option.text }}
      </b-dropdown-item>
    </b-dropdown>
    <b-modal :id="modalId" size="sm" centered :title="$t('policy.acceptance-date')" hide-footer @hidden="acceptanceDateModalClosed">
      <date-picker
        v-model="acceptanceDate"
        :disabled-date="(date) => date > new Date()"
        :first-day-of-week="1"
        :lang="currentLanguage"
        format="DD.MM.YYYY"
        value-type="timestamp"
        :placeholder="$t('policy.acceptance-date')"
      />
      <b-button @click="accept" block variant="primary" class="mt-1">
        {{ $t("common.ok") }}
      </b-button>
    </b-modal>
  </span>
</template>

<script>
import DatePicker from "vue2-datepicker";
import PolicyStatus from "./policy-status";

export default {
  props: ["policy", "showText", "createMode", "disabled"],
  components: {
    PolicyStatus,
    DatePicker,
  },
  computed: {
    selected() {
      return this.selectedAcceptance;
    },
    text() {
      if (this.selectedAcceptance == "UNWORKED") {
        return this.$t("policy.acceptance.unworked");
      } else if (this.selectedAcceptance == "APPLYING") {
        return this.$t("policy.acceptance.applying");
      } else if (this.selectedAcceptance == "NOT_APPLYING") {
        return this.$t("policy.acceptance.not-applying");
      } else if (this.selectedAcceptance == "REJECTED") {
        return this.$t("policy.acceptance.rejected");
      } else if (this.selectedAcceptance == "PERIODIC_APPROVAL") {
        return this.$t("policy.acceptance.periodic-approval");
      }

      return this.$t("policy.acceptance.unworked");
    },
    modalId() {
      return this.unique + (this.policy ? this.policy._id + "acceptance-date-modal" : "acceptance-date-modal");
    },
  },

  data() {
    return {
      oldValue: undefined,
      acceptanceDate: undefined,
      processSuccess: false,
      selectedAcceptance: "UNWORKED",
      unique: undefined,
      options: [
        {
          definition: "APPLYING",
          text: this.$t("policy.acceptance.applying"),
        },
        {
          definition: "NOT_APPLYING",
          text: this.$t("policy.acceptance.not-applying"),
        },
        {
          definition: "REJECTED",
          text: this.$t("policy.acceptance.rejected"),
        },
      ],
    };
  },
  watch: {
    policy: {
      deep: true,
      immediate: true,
      handler(v) {
        if (!v) return;
        this.selectedAcceptance = v.acceptance;
      },
    },
  },
  mounted() {
    this.unique = new Date().getTime();
  },
  methods: {
    async select(item) {
      this.processSuccess = false;
      this.oldValue = this.selectedAcceptance;
      this.selectedAcceptance = item.definition;

      if (item) {
        if (item.definition == "APPLYING") {
          this.$bvModal.show(this.modalId);
        } else if (!this.createMode) {
          this.handle();
        } else if (this.createMode) {
          this.$emit("onSelect", { definition: item.definition });
        }
      }
    },
    async accept() {
      if (this.acceptanceDate) {
        if (this.createMode) {
          this.$emit("onSelect", { definition: this.selectedAcceptance, acceptanceDate: this.acceptanceDate });
        } else {
          await this.handle();
        }
        this.processSuccess = true;
        this.$bvModal.hide(this.modalId);
      }
    },
    async handle() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        this.selectedAcceptance = this.oldValue;
        return;
      }

      await this.$store.dispatch("organizationPolicy/updateStatus", {
        id: this.policy._id,
        acceptance: this.selectedAcceptance,
        acceptanceDate: this.acceptanceDate,
      });
      this.processSuccess = true;

      this.$emit("onSelect", { definition: this.selectedAcceptance.definition });
    },
    acceptanceDateModalClosed() {
      if (!this.processSuccess) {
        this.selectedAcceptance = this.oldValue;
      }
    },
  },
};
</script>
